"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useFilterPresets = () => {
    const [hasInit, setHasInit] = (0, react_1.useState)(false);
    const [presets, setPresets] = (0, react_1.useState)([]);
    const addPreset = (filterName, tuningProps) => {
        if (!tuningProps) {
            return;
        }
        const newPresets = presets.concat({
            name: filterName,
            props: tuningProps,
        });
        setPresets(newPresets);
        localStorage.setItem("filterPresets", JSON.stringify(newPresets));
    };
    const removeFilter = (filterName) => {
        const newPresets = presets.filter((filter) => filter.name !== filterName);
        setPresets(newPresets);
    };
    if (!hasInit) {
        // Retrieve presets from localstorage
        const rawPresets = localStorage.getItem("filterPresets");
        setPresets(rawPresets ? JSON.parse(rawPresets) : []);
        setHasInit(true);
    }
    return { presets: presets, addPreset, removeFilter };
};
exports.default = useFilterPresets;
//# sourceMappingURL=useFilterPresets.js.map